// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".waveform-wrapper[data-v-25f17f0c]{height:3rem}.img-waveform[data-v-25f17f0c]{width:100%;height:3rem;position:absolute;top:0;left:0;opacity:.3333}.img-waveform.elapsed[data-v-25f17f0c]{opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
